var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.loading)?_c('span',[_vm._v(_vm._s(_vm.value))]):_c('loader',{attrs:{"size":14}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }